import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoadModule } from "@shared/components/load/load.module";
import { MenuModule } from "@shared/components/menu/menu.module";
import { SparkPlusModalModule } from "@shared/components/modal/modal.module";
import { SummaryFieldModule } from "@shared/components/summary-field/summary-field.module";
import { PipesModule } from "@shared/pipes/pipes.module";
import { SharedModule } from "@shared/shared.module";
import { ProviderSettingsDisplayComponent } from "./components/provider-settings/display/provider-settings-display.component";
import { ProviderSettingsEditComponent } from "./components/provider-settings/edit/provider-settings-edit.component";
import { SettingsRoutingModule } from "./settings-routing.module";
import { SettingsComponent } from "./views/settings/settings.component";

@NgModule({
  declarations: [
    SettingsComponent,
    ProviderSettingsEditComponent,
    ProviderSettingsDisplayComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    SparkPlusModalModule,
    LoadModule,
    SummaryFieldModule,
    PipesModule,
    SettingsRoutingModule
  ]
})
export class SettingsModule {

}